import { lighten, styled } from '@mui/material/styles'
import { DataGridPro } from '@mui/x-data-grid-pro/DataGridPro'
import { gridClasses } from '@mui/x-data-grid-pro'
import { checkboxClasses } from '@mui/material/Checkbox'

export const rowErrorClass = 'grid-row-error'
export const cellErrorClass = 'grid-cell-error'

const isRolesPage = window?.location?.hash === '#/settings/roles'

export const StyledGrid = styled(DataGridPro)<{
  applyCustomStyles?: boolean
  virtualScrollerHeight?: number
}>(({ theme, applyCustomStyles, virtualScrollerHeight }) => {
  if (applyCustomStyles) {
    return {
      [`&.${gridClasses.root}`]: {
        border: 'none',
      },
      [`& .${gridClasses.footerContainer}`]: {
        position: 'fixed',
        width: '100%',
        bottom: 0,
        left: 0,
        backgroundColor: 'white',
      },
      [`& .${gridClasses.toolbarContainer}`]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
      [`& .${gridClasses.columnHeaders}`]: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        backgroundColor: 'white',
        borderWidth: '1px',
        borderBottomWidth: '0px',
        borderStyle: 'solid',
        borderColor: 'rgba(224, 224, 224, 1)',
        borderTopRadius: '4px',
        overflow: 'hidden',
      },
      [`& .${gridClasses.virtualScrollerContent}`]: {
        backgroundColor: 'white',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'rgba(224, 224, 224, 1)',
        borderTopRadius: '0px',
        borderBottomRadius: '4px',
      },
      [`& .MuiDataGrid-virtualScroller`]: {
        minHeight: `calc(100vh - ${virtualScrollerHeight ? virtualScrollerHeight : isRolesPage ? 360 : 390}px)`,
        maxHeight: `calc(100vh - ${virtualScrollerHeight ? virtualScrollerHeight : isRolesPage ? 360 : 390}px)`,
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        '&::-webkit-scrollbar-track': {
          opacity: 0,
          background: 'rgba(222, 222, 222, .75)',
        },

        '&::-webkit-scrollbar': {
          width: '8px',
          height: '8px',
          opacity: 0,
        },

        '&::-webkit-scrollbar-thumb': {
          opacity: 0,
          borderRadius: '10px',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      },
      [`& .MuiDataGrid-pinnedColumns`]: {
        backgroundColor: 'white',
        boxShadow: 'none',
      },
      [`& .MuiDataGrid-pinnedColumnHeaders`]: {
        backgroundColor: 'white',
        boxShadow: 'none',
      },
      [`& .${rowErrorClass}`]: {
        backgroundColor: `${lighten(
          theme.palette.error.light,
          0.9,
        )} !important`,
      },
      [`& .${cellErrorClass}`]: {
        [`& span.${checkboxClasses.colorPrimary}.${checkboxClasses.checked}`]: {
          color: theme.palette.error.main,
        },
      },
    }
  }
  return {
    [`& .MuiDataGrid-pinnedColumns`]: {
      backgroundColor: 'white',
    },
    [`& .MuiDataGrid-pinnedColumnHeaders`]: {
      backgroundColor: 'white',
    },
    [`& .${rowErrorClass}`]: {
      backgroundColor: `${lighten(theme.palette.error.light, 0.9)} !important`,
    },
    [`& .${cellErrorClass}`]: {
      [`& span.${checkboxClasses.colorPrimary}.${checkboxClasses.checked}`]: {
        color: theme.palette.error.main,
      },
    },
  }
})
